import React from 'react';
import { FiBriefcase, FiBook } from "react-icons/fi";

const iconMap = {
  "briefcase": FiBriefcase,
  "book": FiBook
};

function Smalltitle(props){
  const IconComponent = iconMap[props.icon] || FiStar;

  console.log(props.icons)

  return (
    <div className="mi-smalltitle">
      <span className="mi-smalltitle-icon">
        <IconComponent />
      </span>
      <h4>{props.title}</h4>
    </div>
  )
}

export default Smalltitle;
